import { Typography } from "@/components/atoms/Typography/Typography"

interface ContentItem {
  type: "heading1" | "heading2" | "paragraph" | "list"
  content: string | string[]
}

interface ResourceContentSectionProps {
  items: ContentItem[]
  className?: string
}

export function ResourceContentSection({ items, className = "" }: ResourceContentSectionProps) {
  return (
    <div className={`bg-white text-slate-800 max-w-none px-6 py-4 ${className}`}>
      {items.map((item, index) => {
        switch (item.type) {
          case "heading1":
            return (
              <div key={index} className="mb-8">
                <Typography 
                  variant="h1" 
                  className="text-2xl font-bold text-slate-900 mb-4 leading-tight"
                >
                  {item.content as string}
                </Typography>
              </div>
            )
          case "heading2":
            return (
              <div key={index} className="mb-6">
                <Typography 
                  variant="h2" 
                  className="text-xl font-semibold text-slate-800 mb-3 leading-tight"
                >
                  {item.content as string}
                </Typography>
              </div>
            )
          case "paragraph":
            return (
              <div key={index} className="mb-6">
                <Typography 
                  variant="p" 
                  className="text-base text-slate-700 leading-relaxed"
                >
                  {item.content as string}
                </Typography>
              </div>
            )
          case "list":
            return (
              <div key={index} className="mb-8">
                <ul className="list-disc ml-6 space-y-3">
                  {(item.content as string[]).map((listItem, listIndex) => (
                    <li key={listIndex} className="text-base text-slate-700 leading-relaxed">
                      {listItem}
                    </li>
                  ))}
                </ul>
              </div>
            )
          default:
            return null
        }
      })}
    </div>
  )
}